import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import styles from './styles/user-detail-section.module.scss';

/**
 * Titled section container used inside `UserDetailPanel` (USER DETAILS /
 * PAYROLL SYNC STATUS / ACCOUNT SERVICING). Renders an uppercase title
 * with a top divider and stacks its children with consistent spacing.
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {React.ReactNode} props.children
 */
function UserDetailSection({ title, children }) {
    return (
        <div className={styles.section}>
            <Text
                as={TextAs.H4}
                size={TextSizes.EXTRA_SMALL}
                className={styles.sectionTitle}
            >
                {title}
            </Text>
            <div className={styles.sectionBody}>{children}</div>
        </div>
    );
}

export default UserDetailSection;
